module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo5-13b1ca5e16a1b5fe24cb6b308033af05.png";